export enum UploadIssueFileType {
  TIF = "TIF Tile",
  SHAPEFILE = "Shapefile",
  FBX = "FBX File",
  TILESET = "Cesium 3d Tile",
}
